<!--
 * @Description: 画板组件容器 （配置工具栏）
 * @Autor: WangYuan
 * @Date: 2021-05-24 16:37:58
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-02-12 15:08:36
-->
<template>
  <div
      class="shape"
      :style="{
      'margin-bottom':
        data.styles && data.styles.overlapPadding && data.component == 'McSwiper'
          ? `-${data.styles.overlapPadding}%`
          : 0,
    }"
  >
    <div></div>
    <!-- 组件工具栏 -->
    <div
        v-if="
        data.component != 'waiting' &&
        control.curWidget &&
        control.curWidget.component != 'McExamList' &&
        control.curWidget.component != 'McNews' &&
        control.curWidget.component != 'McIncomeListNew' &&
        control.curWidget.component != 'McTagNav'
      "
        class="shape-tab"
        @click="setcurComponent(data)"
    >
      <!-- 删除 -->
      <template v-if="control.curWidget && control.curWidget.id == data.id">
        <i
            style="z-index: 1000"
            class="icon icon-shanchu tab-icon f16"
            @click.stop="delComponent(data.id)"
        ></i>
      </template>

      <!-- 组件名 -->
      <span v-else>{{ data.name }}</span>
    </div>

    <div
        v-else-if="
        data.component != 'waiting' &&
        control.curWidget &&
        control.curWidget.component == 'McTagNav'
      "
        class="shape-tab-1"
    >
      <!-- 删除 -->
      <template v-if="control.curWidget && control.curWidget.id == data.id">
        <div class="shanchu">
          <i
              style="z-index: 1000"
              class="icon icon-shanchu tab-icon f16"
              @click.stop="delComponent(data.id)"
          ></i>
        </div>
      </template>

      <!-- 组件名 -->
      <span v-else class="shanchu">{{ data.name }}</span>

      <!-- 一二三级配置 -->
      <div
          v-if="control.curWidget && control.curWidget.id == data.id && showLevel > 1"
          class="McTagNavTree"
      >
        <p
            :class="tabIndex == index ? 'active' : ''"
            @click="changeMcTagNavTree(index)"
            v-for="(item, index) in showLevel"
            :key="index"
        >
          {{ index + 1 }}级
        </p>
      </div>

      <div
          v-if="control.curWidget && control.curWidget.id == data.id && showMcTagNav"
          style="
          width: 380px;
          background: #fff;
          position: fixed;
          top: 59px;
          right: 0px;
          height: calc(100vh - 60px);
          z-index: 1000;
        "
      >
        <div class="decorate-head1">
          <div>标签导航层级设置</div>
          <div class="iconset" @click="btnClose" style="cursor: pointer">
            <i class="el-icon-close" style="font-size: 30px; color: #999"></i>
          </div>
        </div>

        <ul v-if="data.otherSet.showType == 'show_tree' && tabIndex == 1">
          <li v-for="(s, key, index) in control.curWidget.treeStyles" :key="index">
            <component
                :key="index"
                :is="typeToComponent[s.type]"
                v-model="control.curWidget.otherSet.secondStyles"
                v-bind="s"
                :schema="s"
            >
              <custom-schema-template
                  v-if="s.child"
                  :schema="s.child"
                  :value="control.curWidget.otherSet.secondStyles"
              ></custom-schema-template>
            </component>
          </li>
        </ul>

        <ul v-if="data.otherSet.showType == 'show_tree' && tabIndex == 2">
          <li v-for="(s, key, index) in control.curWidget.treeStyles" :key="index">
            <component
                :key="index"
                :is="typeToComponent[s.type]"
                v-model="control.curWidget.otherSet.thirdStyles"
                v-bind="s"
                :schema="s"
            >
              <custom-schema-template
                  v-if="s.child"
                  :schema="s.child"
                  :value="control.curWidget.otherSet.thirdStyles"
              ></custom-schema-template>
            </component>
          </li>
        </ul>
      </div>
    </div>

    <div v-else class="shape-tab-1" @click="setcurComponent(data)">
      <!-- 删除 -->
      <template v-if="control.curWidget && control.curWidget.id == data.id">
        <div class="shanchu">
          <i
              style="z-index: 1000"
              class="icon icon-shanchu tab-icon f16"
              @click.stop="delComponent(data.id)"
          ></i>
        </div>
      </template>

      <!-- 组件名 -->
      <span v-else class="shanchu">{{ data.name }}</span>

      <div
          v-if="
          control.curWidget && control.curWidget.id == data.id && control.curWidget.attrs && control.curWidget.attrs.decoratorSource
          && !control.curWidget.attrs.layoutSource
        "
          class="examList"
      >
        <!--新数据源-->
        <div
            class="li"
            style="padding-bottom: 15px"
            v-if="control.curWidget.attrs.decoratorSource.itemW"
        >
          <div
              v-for="(item, index) in control.curWidget.attrs.decoratorSource.pageStyle"
              :key="index"
              class="pageRow mb5"
          >
            <div
                v-for="(items, key1, index1) in item"
                :key="index + '-' + index1"
                class="colSet"
                :style="index1 == 1 ? 'flex:1;min-width:0;overflow:hidden;' : ''"
                v-if="items && (Array.isArray(items) ? items.some(i => i && i.type) : true)"
            >
              <div
                  v-for="(itemss, index2) in items"
                  :key="index + '-' + index1 + '-' + index2"
                  v-if="itemss && itemss.type"
              >
                <div
                    class="lili button-group"
                    :class="
                    buttonGroupIndex1 == index &&
                    buttonGroupIndex2 == index1 &&
                    buttonGroupIndex3 == index2
                      ? 'button_group_active'
                      : ''
                  "
                    @click="showGroup(itemss, index, index1, index2)"
                    v-if="itemss.type == 'button-group' || itemss.type == 'button-switch'"
                >
                  {{ itemss.value }}
                </div>
                <div
                    v-else
                    :style="
                    cur == index + '-' + key1 + '-' + index2
                      ? 'background:#edf4ff;color:#2d7aff;'
                      : ''
                  "
                    class="lili"
                    @click="
                    btnClick(
                      itemss,
                      index + '-' + key1 + '-' + index2,
                      index,
                      key1,
                      index2
                    )
                  "
                    v-html="
                    combinedName(
                      itemss.value,
                      itemss.type,
                      control.curWidget.attrs.decoratorSource.itemW,
                      itemss.style
                    )
                  "
                ></div>
              </div>
            </div>

            <div
                class="colSet btnBuy"
                v-if="
                index == control.curWidget.attrs.decoratorSource.pageStyle.length - 1 &&
                control.curWidget.component == 'McExamList'
              "
            >
              {{
                control.curWidget.attrs.decoratorSource.itemW.buyFlag ||
                control.curWidget.attrs.decoratorSource.itemW.freeFlag == 1
                    ? "立即练习"
                    : "立即购买"
              }}
            </div>
          </div>
        </div>

        <!--旧数据源-->
        <div class="li" style="padding-bottom: 40px" v-else>
          <div
              v-for="(item, index) in control.curWidget.attrs.decoratorSource.pageStyle"
              :key="index"
              class="pageRow mb5"
          >
            <div
                v-for="(items, index1) in item"
                :key="index + '-' + index1"
                class="colSet"
                :style="index1 == 0 ? 'flex:1' : ''"
            >
              <div
                  v-for="(itemss, index2) in items"
                  :key="index + '-' + index1 + '-' + index2"
                  v-if="itemss && itemss.type"
                  :style="
                  cur == index + '-' + index1 + '-' + index2
                    ? 'background:#edf4ff;color:#2d7aff;'
                    : ''
                "
                  class="lili"
                  @click="
                  btnClick(
                    itemss,
                    index + '-' + index1 + '-' + index2,
                    index,
                    index1,
                    index2
                  )
                "
                  v-html="combinedName(itemss.value, itemss.type, itemW, itemss.style)"
              ></div>
            </div>

            <div
                class="colSet btnBuy"
                v-if="
                index == control.curWidget.attrs.decoratorSource.pageStyle.length - 1 &&
                control.curWidget.component == 'McExamList'
              "
            >
              {{ itemW.buyFlag || itemW.freeFlag == 1 ? "立即练习" : "立即购买" }}
            </div>
          </div>
        </div>

        <div
            class="mt10"
            style="
            padding: 0 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div v-show="styleIndex < 0" class="setDefStyle" @click="saveStyle">
            保存样式
          </div>
          <div v-show="styleIndex >= 0" class="setDefStyle" @click="editStyle({}, true)">
            修改样式
          </div>
          <div class="resetStyle" @click="reset">重置</div>
        </div>
        <div class="style_ul_box">
          <p>历史样式</p>
          <ul>
            <li
                v-for="(item, index) in getStyle"
                :key="index"
                :class="styleIndex == index ? 'active' : ''"
                @click="changeStyleIndex(index)"
            >
              <span>{{ item.name }}</span>
              <p>
                <span class="time">{{ item.createTime }}</span>
                <el-popover
                    placement="right"
                    width="150"
                    trigger="click"
                    @click.native="handlePopoverClick($event, index)"
                >
                  <div style="color: #101010; font-weight: bold">
                    <p
                        style="height: 30px; line-height: 30px; cursor: pointer"
                        @click="setDefaultStyle(item)"
                    >
                      <i class="el-icon-setting"></i>
                      <span style="margin-left: 10px">设置为默认样式</span>
                    </p>
                    <p
                        style="height: 30px; line-height: 30px; cursor: pointer"
                        @click="editStyle(item, false)"
                    >
                      <i class="el-icon-edit"></i>
                      <span style="margin-left: 10px">重命名</span>
                    </p>
                    <p
                        style="height: 30px; line-height: 30px; cursor: pointer"
                        @click="deteleStyle(item)"
                    >
                      <i class="el-icon-delete"></i>
                      <span style="margin-left: 10px">删除</span>
                    </p>
                  </div>
                  <i class="el-icon-more" slot="reference"></i>
                </el-popover>
              </p>
            </li>
            <li v-if="styleList.length <= 0">
              {{ loading ? "查询中…" : "暂无样式" }}
            </li>
          </ul>
        </div>
      </div>

      <div
          v-if="control.curWidget && control.curWidget.id == data.id && buttonGroupShow && control.curWidget.attrs.decoratorSource && !control.curWidget.attrs.layoutSource"
          class="buttonGroup_box"
      >
        <div class="decorate-head1">
          <div>渠道商或管理员招募信息</div>
          <div class="iconset" @click="btnClose" style="cursor: pointer">
            <i class="el-icon-close" style="font-size: 30px; color: #999"></i>
          </div>
        </div>
        <ul>
          <li v-for="(s, key, index) in control.curWidget.treeStyles" :key="index">
            <component
                :key="index"
                :is="typeToComponent[s.type]"
                v-model="
                control.curWidget.attrs.decoratorSource.buttonGroupStyle[
                  buttonGroupIndex1
                ][buttonGroupIndex2][buttonGroupIndex3]
              "
                v-bind="s"
                :dataSource="control.curWidget.attrs.dataSource"
                :schema="s"
            >
              <custom-schema-template
                  v-if="s.child"
                  :schema="s.child"
                  :value="
                  control.curWidget.attrs.decoratorSource.buttonGroupStyle[
                    buttonGroupIndex1
                  ][buttonGroupIndex2][buttonGroupIndex3]
                "
                  :dataSource="control.curWidget.attrs.dataSource"
              ></custom-schema-template>
            </component>
          </li>
        </ul>
      </div>

      <div
          v-if="
          control.curWidget && control.curWidget.id == data.id && cur != -1 && showSet
        "
          style="
          width: 380px;
          background: #fff;
          position: fixed;
          top: 59px;
          right: 0px;
          height: calc(100vh - 60px);
          z-index: 1000;
        "
      >
        <div class="decorate-head1">
          <div>{{ control.curWidget.attrs.decoratorSource.decoratorName }}</div>
          <div class="iconset" @click="btnClose" style="cursor: pointer">
            <i class="el-icon-close" style="font-size: 30px; color: #999"></i>
          </div>
        </div>

        <div class="setTit">
          <span>样式设置</span>
        </div>

        <!--文本大小/图标大小-->
        <div
            class="select"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type != 'icon' &&
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type != 'image' &&
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type != 'divider'
          "
        >
          <ul class="select-label">
            <li class="select-label-text">{{ textSize.label }}</li>
          </ul>

          <div class="select-body">
            <el-tooltip
                class="item"
                effect="light"
                v-for="(item, index) in textSize.data"
                :key="index"
                :content="item.label"
                placement="bottom"
                :open-delay="200"
            >
              <div
                  class="mode-select-item flex-center"
                  :class="[
                  item.value ==
                  control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                    curIndex2
                  ]['style']['font-size']
                    ? 'mode-select-item-active'
                    : '',
                ]"
                  @click="clickItem(item.value, 'font-size')"
              >
                <span>{{ item.label }}</span>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div
            class="select"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type == 'icon'
          "
        >
          <ul class="select-label">
            <li class="select-label-text">{{ iconSize.label }}</li>
          </ul>

          <div class="select-body">
            <el-tooltip
                class="item"
                effect="light"
                v-for="(item, index) in iconSize.data"
                :key="index"
                :content="item.label"
                placement="bottom"
                :open-delay="200"
            >
              <div
                  class="mode-select-item flex-center"
                  :class="[
                  item.value ==
                  control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                    curIndex2
                  ]['style']['font-size']
                    ? 'mode-select-item-active'
                    : '',
                ]"
                  @click="clickItem(item.value, 'font-size')"
              >
                <span>{{ item.label }}</span>
              </div>
            </el-tooltip>
          </div>
        </div>

        <!--字体粗细-->
        <div
            class="select"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type != 'icon' &&
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type != 'image' &&
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type != 'divider'
          "
        >
          <ul class="select-label">
            <li class="select-label-text">{{ textWeight.label }}</li>
          </ul>

          <div class="select-body">
            <el-tooltip
                class="item"
                effect="light"
                v-for="(item, index) in textWeight.data"
                :key="index"
                :content="item.label"
                placement="bottom"
                :open-delay="200"
            >
              <div
                  class="mode-select-item flex-center"
                  :class="[
                  item.value ==
                  control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                    curIndex2
                  ]['style']['font-weight']
                    ? 'mode-select-item-active'
                    : '',
                ]"
                  @click="clickItem(item.value, 'font-weight')"
              >
                <span>{{ item.label }}</span>
              </div>
            </el-tooltip>
          </div>
        </div>

        <!--图片宽高圆角-->
        <div
            class="flex p10 bg-white"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type == 'image'
          "
        >
          <div class="w80 f13 f-grey" style="padding-top: 12px">
            {{ imageWidth.label }}
          </div>
          <div class="flex-1">
            <el-slider
                v-model="imageWidth.value"
                @change="changeMargin($event, 'width')"
                show-input
            >
            </el-slider>
          </div>
        </div>
        <div
            class="flex p10 bg-white"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type == 'image'
          "
        >
          <div class="w80 f13 f-grey" style="padding-top: 12px">
            {{ imageHeight.label }}
          </div>
          <div class="flex-1">
            <el-slider
                v-model="imageHeight.value"
                @change="changeMargin($event, 'height')"
                show-input
            >
            </el-slider>
          </div>
        </div>
        <div
            class="flex p10 bg-white"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type == 'image'
          "
        >
          <div class="w80 f13 f-grey" style="padding-top: 12px">
            {{ imageRadius.label }}
          </div>
          <div class="flex-1">
            <el-slider
                v-model="imageRadius.value"
                @change="changeMargin($event, 'borderRadius')"
                show-input
            >
            </el-slider>
          </div>
        </div>

        <!--文字颜色-->
        <div
            class="select"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type != 'image' &&
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type != 'priceF' &&
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type != 'priceY' &&
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type != 'divider'
          "
        >
          <ul class="select-label">
            <li class="select-label-text">
              {{ curInfo.type == "icon" ? "图标颜色" : "文字颜色" }}
            </li>
          </ul>

          <div
              class="flex"
              style="justify-content: end; align-items: center; margin-right: 25px"
          >
            <span class="f12 f-theme pointer" @click="bindReset">重置</span>
            <el-color-picker
                v-model="
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                  curIndex2
                ]['style']['color']
              "
                :predefine="predefineColors"
                @change="changeColor"
            ></el-color-picker>
          </div>
        </div>

        <!--价格颜色-->
        <div
            class="select"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type == 'priceF' ||
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type == 'priceY'
          "
        >
          <ul class="select-label">
            <li class="select-label-text">{{ freeColorSet.label }}</li>
          </ul>

          <div
              class="flex"
              style="justify-content: end; align-items: center; margin-right: 25px"
          >
            <span class="f12 f-theme pointer" @click="bindReset">重置</span>
            <el-color-picker
                v-model="
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                  curIndex2
                ]['style']['freeColor']
              "
                @change="changeColor"
                :predefine="predefineColors"
            ></el-color-picker>
          </div>
        </div>

        <div
            class="select"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type == 'priceF' ||
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type == 'priceY'
          "
        >
          <ul class="select-label">
            <li class="select-label-text">{{ noFreeColorSet.label }}</li>
          </ul>

          <div
              class="flex"
              style="justify-content: end; align-items: center; margin-right: 25px"
          >
            <span class="f12 f-theme pointer" @click="bindReset">重置</span>
            <el-color-picker
                v-model="
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                  curIndex2
                ]['style']['noFreeColor']
              "
                @change="changeColor"
                :predefine="predefineColors"
            ></el-color-picker>
          </div>
        </div>

        <!--标签背景颜色-->
        <div
            class="select"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type == 'textArray' ||
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type == 'divider'
          "
        >
          <ul class="select-label">
            <li class="select-label-text">
              {{
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                    curIndex2
                    ].type == "textArray"
                    ? "标签颜色"
                    : "分割线颜色"
              }}
            </li>
          </ul>

          <div
              class="flex"
              style="justify-content: end; align-items: center; margin-right: 25px"
          >
            <span class="f12 f-theme pointer" @click="bindReset1">重置</span>
            <el-color-picker
                v-model="
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                  curIndex2
                ]['style']['background']
              "
                @change="changeColor"
                :predefine="predefineColors"
            ></el-color-picker>
          </div>
        </div>

        <!--内容背景色 (text/text-s/textS/address-*)-->
        <div
            class="select"
            v-if="
            isContentStyleType(
              control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                curIndex2
              ].type
            )
          "
        >
          <ul class="select-label">
            <li class="select-label-text">内容背景</li>
          </ul>

          <div
              class="flex"
              style="justify-content: end; align-items: center; margin-right: 25px"
          >
            <span class="f12 f-theme pointer" @click="resetContentStyle('contentBck')">重置</span>
            <el-color-picker
                v-model="
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                  curIndex2
                ]['style']['contentBck']
              "
                @change="changeColor"
                :predefine="predefineColors"
            ></el-color-picker>
          </div>
        </div>

        <!--内容填充-->
        <div
            class="flex p10 bg-white"
            v-if="
            isContentStyleType(
              control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                curIndex2
              ].type
            )
          "
        >
          <div class="w80 f13 f-grey" style="padding-top: 12px">
            内容填充
          </div>
          <div class="flex-1">
            <el-slider
                v-model="
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                  curIndex2
                ]['style']['contentPadding']
              "
                @change="changeMargin($event, 'contentPadding')"
                :min="0"
                :max="30"
                show-input
            >
            </el-slider>
          </div>
        </div>

        <!--内容圆角-->
        <div
            class="flex p10 bg-white"
            v-if="
            isContentStyleType(
              control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                curIndex2
              ].type
            )
          "
        >
          <div class="w80 f13 f-grey" style="padding-top: 12px">
            内容圆角
          </div>
          <div class="flex-1">
            <el-slider
                v-model="
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                  curIndex2
                ]['style']['contentBorderRadius']
              "
                @change="changeMargin($event, 'contentBorderRadius')"
                :min="0"
                :max="30"
                show-input
            >
            </el-slider>
          </div>
        </div>

        <!--上边距-->
        <div class="flex p10 bg-white">
          <div class="w80 f13 f-grey" style="padding-top: 12px">
            {{ marginTopSet.label }}
          </div>
          <div class="flex-1">
            <el-slider
                v-model="
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                  curIndex2
                ]['style']['margin-top']
              "
                @change="changeMargin($event, 'margin-top')"
                show-input
            >
            </el-slider>
          </div>
        </div>

        <!--下边距-->
        <div class="flex p10 bg-white">
          <div class="w80 f13 f-grey" style="padding-top: 12px">
            {{ marginBottomSet.label }}
          </div>
          <div class="flex-1">
            <el-slider
                v-model="
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                  curIndex2
                ]['style']['margin-bottom']
              "
                @change="changeMargin($event, 'margin-bottom')"
                show-input
            >
            </el-slider>
          </div>
        </div>

        <!--标签间距-->
        <div
            class="flex p10 bg-white"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type == 'textArray'
          "
        >
          <div class="w80 f13 f-grey" style="padding-top: 12px">
            {{ tagMarginLeft.label }}
          </div>
          <div class="flex-1">
            <el-slider
                v-model="
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                  curIndex2
                ]['style']['tagMrginLeft']
              "
                @change="changeMargin($event, 'tagMrginLeft')"
                show-input
            >
            </el-slider>
          </div>
        </div>

        <!--左边距-->
        <div
            class="flex p10 bg-white"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type != 'divider'
          "
        >
          <div class="w80 f13 f-grey" style="padding-top: 12px">
            {{ marginLeftSet.label }}
          </div>
          <div class="flex-1">
            <el-slider
                v-model="
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                  curIndex2
                ]['style']['margin-left']
              "
                @change="changeMargin($event, 'margin-left')"
                show-input
            >
            </el-slider>
          </div>
        </div>

        <!--右边距-->
        <div
            class="flex p10 bg-white"
            v-if="
            control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
              curIndex2
            ].type != 'divider'
          "
        >
          <div class="w80 f13 f-grey" style="padding-top: 12px">
            {{ marginRightSet.label }}
          </div>
          <div class="flex-1">
            <el-slider
                v-model="
                control.curWidget.attrs.decoratorSource.pageStyle[curIndex][curIndex1][
                  curIndex2
                ]['style']['margin-right']
              "
                @change="changeMargin($event, 'margin-right')"
                show-input
            >
            </el-slider>
          </div>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getDecoratorPage,
  addDecorator,
  getDecoratorView,
  delDecorator,
  editDecorator,
  getDecoratorList,
  setDefaultDecorator,
} from "@/api/easyApp.js";
import { deepClone } from "@/js/utils";
import typeToComponent from "@/config/schema-template";

export default {
  name: "shape",

  inject: ["control"],

  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      buttonGroupIndex1: -1,
      buttonGroupIndex2: -1,
      buttonGroupIndex3: -1,
      buttonGroupShow: false,
      typeToComponent,
      tabIndex: 0,
      showLevel: 1,
      showMcTagNav: false,
      oldStyle: null,
      styleEdit: false,
      styleIndex: -1,
      styleName: "样式名称",
      styleList: [],
      decoratorStyleList: [],
      showSet: false, //展示设置
      cur: -1,
      curInfo: {},
      curIndex: -1,
      curIndex1: -1,
      curIndex2: -1,
      itemW: {
        questionBankId: "1836650204949966849",
        name: "题库测试",
        descr: "题库测试",
        questionNum: 0,
        useCount: 0,
        rightCount: 0,
        errorCount: 0,
        rightRate: 0.0,
        errorRate: 0.0,
        createUserId: "1",
        createUserName: "admin",
        updateUserId: "1",
        updateUserName: "admin",
        createTime: "2024-09-19 14:15:07",
        updateTime: "2024-09-19 14:16:44",
        delFlag: 0,
        studyNumber: 0,
        studyPersonNumber: 0,
        amount: 0,
        payAmount:0,
        score: 10,
        costTime: 60,
        questionBankName: "题库测试",
        status: 3,
      },
      tagMarginLeft: {
        label: "标签右边距",
        type: "number",
        value: 12,
        options: {
          max: 50,
        },
      },
      marginTopSet: {
        label: "上边距",
        type: "number",
        value: 12,
        options: {
          max: 50,
        },
      },
      marginBottomSet: {
        label: "下边距",
        type: "number",
        value: 12,
        options: {
          max: 50,
        },
      },
      marginLeftSet: {
        label: "左边距",
        type: "number",
        value: 12,
        options: {
          max: 50,
        },
      },
      marginRightSet: {
        label: "右边距",
        type: "number",
        value: 12,
        options: {
          max: 50,
        },
      },
      colorSet: {
        label: "颜色",
        value: "#323233",
      },
      freeColorSet: {
        label: "免费颜色",
        value: "#323233",
      },
      noFreeColorSet: {
        label: "收费颜色",
        value: "#323233",
      },
      textSize: {
        label: "字体大小",
        value: "16px",
        data: [
          {
            label: "大(16号)",
            value: "16px",
          },
          {
            label: "中(14号)",
            value: "14px",
          },
          {
            label: "小(12号)",
            value: "12px",
          },
        ],
      },
      textWeight: {
        label: "字体粗细",
        value: "bold",
        data: [
          {
            label: "标准",
            value: "normal",
          },
          {
            label: "加粗",
            value: "bold",
          },
        ],
      },
      iconSize: {
        label: "图标大小",
        value: "15px",
        data: [
          {
            label: "大(25号)",
            value: "25px",
          },
          {
            label: "中(20号)",
            value: "20px",
          },
          {
            label: "小(15号)",
            value: "15px",
          },
        ],
      },
      imageWidth: {
        label: "图片宽度",
        type: "number",
        value: 20,
        options: {
          max: 100,
        },
      },
      imageHeight: {
        label: "图片高度",
        type: "number",
        value: 20,
        options: {
          max: 100,
        },
      },
      imageRadius: {
        label: "图片圆角",
        type: "number",
        value: 0,
        options: {
          max: 100,
        },
      },
      btnBckSet: {
        label: "颜色",
        type: "color",
        value: "#ffffff",
        options: {
          default: "#ffffff",
        },
      },
      tagBckSet: {
        label: "颜色",
        type: "color",
        value: "#f5f5f5",
        options: {
          default: "#f5f5f5",
        },
      },

      predefineColors: [
        "#ffffff",
        "#f5f5f5",
        "#F2F2F2",
        "#FF4444",
        "#FFCD00",
        "#3FBC87",
        "#5197FF",
        "#BADCFF",
        "#000000",
      ],
      decoratorId: "",
      loading: false,
      decoratorListOldStyle: new Map(),
    };
  },
  computed: {
    ...mapGetters(["project"]),
    getStyle() {
      return this.styleList;
    },
  },
  watch: {
    "control.curWidget.attrs.decoratorSource.decoratorId": {
      handler(newValue, oldValue) {
        if (newValue) {
          this.getStyleList();

          //初始化，按钮组
          // this.initGroupBottom();
        }
      },
      deep: true,
    },
    "control.curWidget.otherSet": {
      handler(newValue, oldValue) {
        if (newValue && newValue.showLevel && newValue.showType == "show_tree") {
          this.showLevel = Number(newValue.showLevel);
        } else {
          this.showLevel = 1;
        }
      },
      deep: true,
    },
  },
  mounted() {
    setTimeout(() => {
      if (
          this.control.curWidget &&
          this.control.curWidget.attrs &&
          this.control.curWidget.attrs.decoratorSource &&
          this.control.curWidget.attrs.decoratorSource.decoratorId != ""
      ) {
        if (
            this.control.curWidget.component == "McExamList" ||
            this.control.curWidget.component == "McNews" ||
            this.control.curWidget.component == "McIncomeListNew"
        ) {
          this.getStyleList();
        }
      }
    }, 500);
  },
  methods: {
    //初始化按钮组
    // initGroupBottom() {
    //   console.log(this.control.curWidget.attrs.decoratorSource);
    //   this.buttonGroupIndex1 = -1;
    //   this.buttonGroupIndex2 = -1;
    //   this.buttonGroupIndex3 = -1;
    //   let arr = this.control.curWidget.attrs.decoratorSource.buttonGroupStyle;
    //   for (
    //     let i = 0;
    //     i < this.control.curWidget.attrs.decoratorSource.pageStyle.length;
    //     i++
    //   ) {
    //     if (!arr[i]) {
    //       arr[i] = [];
    //     }
    //     Object.entries(this.control.curWidget.attrs.decoratorSource.pageStyle[i]).forEach(
    //       ([key, value]) => {
    //         let index2 = key == "left" ? 0 : key == "center" ? 1 : 2;
    //         if (!arr[i][index2]) {
    //           arr[i][index2] = [];
    //         }
    //         for (
    //           let k = 0;
    //           k < this.control.curWidget.attrs.decoratorSource.pageStyle[i][key].length;
    //           k++
    //         ) {
    //           if (!arr[i][index2][k]) {
    //             arr[i][index2][k] = deepClone(
    //               this.control.curWidget.attrs.decoratorSource.defaultGroupStyle
    //             );
    //           }
    //         }
    //       }
    //     );
    //   }
    //   this.$set(this.control.curWidget.attrs.decoratorSource, "buttonGroupStyle", arr);
    //   console.log(this.control.curWidget.attrs.decoratorSource.buttonGroupStyle);
    // },

    //点击按钮组弹窗
    showGroup(item, index1, index2, index3) {
      this.btnClose();
      this.buttonGroupIndex1 = index1;
      this.buttonGroupIndex2 = index2;
      this.buttonGroupIndex3 = index3;

      setTimeout(() => {
        this.buttonGroupShow = true;
      }, 100);
    },

    //点击导航分级
    changeMcTagNavTree(index) {
      this.tabIndex = index;

      //显示层级样式
      if (this.tabIndex != 0) {
        this.showMcTagNav = true;
      } else {
        this.showMcTagNav = false;
      }
    },

    //重置样式
    reset() {
      this.control.curWidget.attrs.decoratorSource.pageStyle = this.decoratorListOldStyle.get(
          this.decoratorId
      );
      if (this.control.curWidget.attrs.decoratorSource.decoratorList) {
        this.control.curWidget.attrs.decoratorSource.decoratorList[
            this.decoratorId
            ].pageStyle = this.decoratorListOldStyle.get(this.decoratorId);
      }
      this.styleIndex = -1;
    },

    //阻止冒泡
    handlePopoverClick(event, index) {
      event.stopPropagation(); // 阻止事件冒泡
      if (this.styleIndex != index) {
        this.styleIndex = index;
        this.control.curWidget.attrs.decoratorSource.pageStyle = JSON.parse(
            this.styleList[index].config
        );
      }
    },

    //统一报错
    errorMsg(msg) {
      this.$message({
        type: "warning",
        message: msg,
      });
    },

    //点击样式
    changeStyleIndex(index) {
      if (this.styleIndex == index) {
        this.reset();
      } else {
        this.styleIndex = index;
        this.control.curWidget.attrs.decoratorSource.pageStyle = JSON.parse(
            this.styleList[index].config
        );

        if (this.control.curWidget.attrs.decoratorSource.decoratorList) {
          this.control.curWidget.attrs.decoratorSource.decoratorList[
              this.decoratorId
              ].pageStyle = JSON.parse(this.styleList[index].config);
        }
      }
    },

    //根据id查询样式列表
    async getStyleList() {
      let params = {
        id: this.control.curWidget.attrs.decoratorSource.decoratorId,
      };
      this.styleList = [];
      this.loading = true;
      getDecoratorList(params)
          .then((res) => {
            this.loading = false;
            if (res.code == 0) {
              this.styleList = res.data;
              if (
                  this.decoratorId != this.control.curWidget.attrs.decoratorSource.decoratorId
              ) {
                this.decoratorId = this.control.curWidget.attrs.decoratorSource.decoratorId;
                if (this.control.curWidget.attrs.decoratorSource.decoratorList) {
                  if (this.decoratorListOldStyle.has(this.decoratorId)) {
                  } else {
                    this.decoratorListOldStyle.set(
                        this.decoratorId,
                        this.control.curWidget.attrs.decoratorSource.decoratorList[
                            this.decoratorId
                            ].pageStyle
                    );
                  }
                } else {
                  if (this.decoratorListOldStyle.has(this.decoratorId)) {
                  } else {
                    this.decoratorListOldStyle.set(
                        this.decoratorId,
                        this.control.curWidget.attrs.decoratorSource.pageStyle
                    );
                  }
                }
              }
              if (this.styleList.length > 0) {
                this.styleIndex = -1;
                //取消默认赋值
              }
            } else {
              this.errorMsg(res.msg);
            }
          })
          .catch((err) => {
            this.loading = false;
          });
    },

    //保存样式
    saveStyle() {
      let params = {
        decoratorId: this.control.curWidget.attrs.decoratorSource.decoratorId,
        name: "样式",
        config: JSON.stringify(this.control.curWidget.attrs.decoratorSource.pageStyle),
        defaultStatus: false,
      };
      addDecorator(params).then((res) => {
        if (res.code == 0) {
          this.$message({ message: "保存成功", type: "success" });
          this.getStyleList();
        } else {
          this.errorMsg(res.msg);
        }
      });
    },

    //修改样式
    editStyle(item, flag) {
      if (flag) {
        this.$confirm("确认修改该样式?", "", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = {
            decoratorStyleId: this.styleList[this.styleIndex].decoratorStyleId,
            decoratorId: this.styleList[this.styleIndex].decoratorId,
            name: this.styleList[this.styleIndex].name,
            config: JSON.stringify(
                this.control.curWidget.attrs.decoratorSource.pageStyle
            ),
            defaultStatus: true,
          };
          editDecorator(params).then((res) => {
            if (res.code == 0) {
              this.$message({ message: "修改成功", type: "success" });
              this.getStyleList();
            } else {
              this.errorMsg(res.msg);
            }
          });
        });
      } else {
        this.$prompt("请输入样式名称", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
            .then(({ value }) => {
              let params = {
                decoratorStyleId: item.decoratorStyleId,
                decoratorId: item.decoratorId,
                name: value,
                config: item.config,
                defaultStatus: true,
              };
              editDecorator(params).then((res) => {
                if (res.code == 0) {
                  this.$message({ message: "修改成功", type: "success" });
                  this.getStyleList();
                } else {
                  this.errorMsg(res.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消输入",
              });
            });
      }
    },

    //删除样式
    deteleStyle(item) {
      this.$confirm("确认要进行删除操作吗?", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = [item.decoratorStyleId];
        delDecorator(params).then((res) => {
          if (res.code == 0) {
            this.$message({ message: "删除成功", type: "success" });
            this.getStyleList();
          } else {
            this.errorMsg(res.msg);
          }
        });
      });
    },

    //设置默认样式
    setDefaultStyle(item) {
      this.$confirm("是否设置为默认样式？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: item.decoratorStyleId,
        };
        setDefaultDecorator(params).then((res) => {
          if (res.code == 0) {
            this.$message({ message: "设置默认样式成功", type: "success" });
            this.getStyleList();
          } else {
            this.errorMsg(res.msg);
          }
        });
      });
    },

    getRealShowContent(dataMapper, target, item) {
      if (target == "formTag") {
      }
      let filePath = this.project.filePath
          ? this.project.filePath
          : "https://cdn.zhaosheng.daheyun1314.com/";

      console.log("dataMapper:",dataMapper,"target:",target);

      let index = dataMapper.findIndex((item) => item.target == target);

      console.log("===index======:",index);

      if (index != -1) {
        if (dataMapper[index].source.split(".").length == 2) {
          if (item[dataMapper[index].source.split(".")[0]]) {
            return item[dataMapper[index].source.split(".")[0]][
                dataMapper[index].source.split(".")[1]
                ];
          } else {
            return "";
          }
        } else if (target == "cover") {
          if (
              item[dataMapper[index].source] &&
              item[dataMapper[index].source]?.includes(filePath)
          ) {
            return item[dataMapper[index].source] + "?x-oss-process=style/goods150";
          } else {
            return item[dataMapper[index].source];
          }
        } else {
          return item[dataMapper[index].source];
        }
      } else {
        return "";
      }

    },
    getRealShowContentDesc(dataMapper, target, item) {
      let index = dataMapper.findIndex((item) => item.target == target);
      if (index != -1) {
        let obj = {
          sign: dataMapper[index].source,
          dicts: dataMapper[index].dicts ? dataMapper[index].dicts : [],
        };
        return obj;
        // return item[dataMapper[index].source];
      } else {
        return "";
      }
    },
    clickItem(value, fontStyle) {
      this.control.curWidget.attrs.decoratorSource.pageStyle[this.curIndex][
          this.curIndex1
          ][this.curIndex2]["style"][fontStyle] = value;
      if (
          this.control.curWidget.attrs.decoratorSource.defaultDecoratorId &&
          this.control.curWidget.attrs.decoratorSource.decoratorId ==
          this.control.curWidget.attrs.decoratorSource.defaultDecoratorId
      ) {
        this.control.curWidget.attrs.decoratorSource.defaultPageStyle = this.control.curWidget.attrs.decoratorSource.pageStyle;
      }
      if (this.control.curWidget.attrs.decoratorSource.showRoleList == true) {
        this.control.curWidget.attrs.decoratorSource.decoratorList[
            this.control.curWidget.attrs.decoratorSource.decoratorId
            ].pageStyle = this.control.curWidget.attrs.decoratorSource.pageStyle;
      }
    },
    changeMargin(value, fontStyle) {
      this.control.curWidget.attrs.decoratorSource.pageStyle[this.curIndex][
          this.curIndex1
          ][this.curIndex2]["style"][fontStyle] = value;
      if (
          this.control.curWidget.attrs.decoratorSource.defaultDecoratorId &&
          this.control.curWidget.attrs.decoratorSource.decoratorId ==
          this.control.curWidget.attrs.decoratorSource.defaultDecoratorId
      ) {
        this.control.curWidget.attrs.decoratorSource.defaultPageStyle = this.control.curWidget.attrs.decoratorSource.pageStyle;
      }

      if (this.control.curWidget.attrs.decoratorSource.showRoleList == true) {
        this.control.curWidget.attrs.decoratorSource.decoratorList[
            this.control.curWidget.attrs.decoratorSource.decoratorId
            ].pageStyle = this.control.curWidget.attrs.decoratorSource.pageStyle;
      }
    },
    bindReset() {
      this.control.curWidget.attrs.decoratorSource.pageStyle[this.curIndex][
          this.curIndex1
          ][this.curIndex2]["style"]["color"] = "#232323";

      if (
          this.control.curWidget.attrs.decoratorSource.defaultDecoratorId &&
          this.control.curWidget.attrs.decoratorSource.decoratorId ==
          this.control.curWidget.attrs.decoratorSource.defaultDecoratorId
      ) {
        this.control.curWidget.attrs.decoratorSource.defaultPageStyle = this.control.curWidget.attrs.decoratorSource.pageStyle;
      }

      if (this.control.curWidget.attrs.decoratorSource.showRoleList == true) {
        this.control.curWidget.attrs.decoratorSource.decoratorList[
            this.control.curWidget.attrs.decoratorSource.decoratorId
            ].pageStyle = this.control.curWidget.attrs.decoratorSource.pageStyle;
      }
    },
    changeColor(e) {
      if (
          this.control.curWidget.attrs.decoratorSource.defaultDecoratorId &&
          this.control.curWidget.attrs.decoratorSource.decoratorId ==
          this.control.curWidget.attrs.decoratorSource.defaultDecoratorId
      ) {
        this.control.curWidget.attrs.decoratorSource.defaultPageStyle = this.control.curWidget.attrs.decoratorSource.pageStyle;
      }

      if (this.control.curWidget.attrs.decoratorSource.showRoleList == true) {
        this.control.curWidget.attrs.decoratorSource.decoratorList[
            this.control.curWidget.attrs.decoratorSource.decoratorId
            ].pageStyle = this.control.curWidget.attrs.decoratorSource.pageStyle;
      }
    },
    bindReset1() {
      this.control.curWidget.attrs.decoratorSource.pageStyle[this.curIndex][
          this.curIndex1
          ][this.curIndex2]["style"]["background"] = "#f5f5f5";
      if (
          this.control.curWidget.attrs.decoratorSource.defaultDecoratorId &&
          this.control.curWidget.attrs.decoratorSource.decoratorId ==
          this.control.curWidget.attrs.decoratorSource.defaultDecoratorId
      ) {
        this.control.curWidget.attrs.decoratorSource.defaultPageStyle = this.control.curWidget.attrs.decoratorSource.pageStyle;
      }

      if (this.control.curWidget.attrs.decoratorSource.showRoleList == true) {
        this.control.curWidget.attrs.decoratorSource.decoratorList[
            this.control.curWidget.attrs.decoratorSource.decoratorId
            ].pageStyle = this.control.curWidget.attrs.decoratorSource.pageStyle;
      }
    },
    getLabel(value) {
      return this.titleSize.data.find((v) => v.value == value)?.label || "暂无匹配";
    },
    btnClose() {
      this.showSet = false;
      this.showMcTagNav = false;
      this.buttonGroupShow = false;
      this.tabIndex = 0;
      this.buttonGroupIndex1 = -1;
      this.buttonGroupIndex2 = -1;
      this.buttonGroupIndex3 = -1;
    },
    btnClick(itemss, row, index, index1, index2) {
      //console.log("");
      this.curIndex = index;
      this.curIndex1 = index1;
      this.curIndex2 = index2;

      this.curInfo = itemss;
      this.cur = row;
      this.showSet = true;
      //this.curIndex=index;

      this.buttonGroupShow = false;
      this.buttonGroupIndex1 = -1;
      this.buttonGroupIndex2 = -1;
      this.buttonGroupIndex3 = -1;
    },
    combinedName(value, type, item, style) {
      let message = "";
      let showMessage = "";
      if (type == "text" || type == "textS") {
        showMessage = '<span style="display:inline-flex;align-items:center;">';
        message = value.split("}}");
        for (var i in message) {
          if (message[i].indexOf("{{") != -1) {
            let a = message[i].split("{{");
            showMessage += "<span>" + a[0] + "</span>";
            a = a[1];

            let res = this.getRealShowContentDesc(
                this.control.curWidget.attrs.dataSource.dataMapper,
                a,
                item
            );
            if (res.dicts && res.dicts.length > 0) {
              let showResult = res.dicts.filter((items) => items.value == item[res.sign]);
              showMessage += "<span>" + showResult[0].label + "</span>";
            } else {
              let showResult = item[res.sign];
              showMessage += "<span>" + showResult + "</span>";
            }
          } else {
            showMessage += "<span>" + message[i] + "</span>";
          }
        }
        showMessage += "</span>";
      }
      else if (type == "add-minus") {
        showMessage = '<span style="display:inline-flex;align-items:center;">';
        message = value.split("{{");
        let one = message[1].split("}}");
        let one1 = one[0];
        let one2 = one[1];
        let two = message[2].split("}}");
        let two1 = two[0];
        let two2 = two[1].split("?");
        two2 = two2[1].split(":")[0];

        let oneResult = this.getRealShowContent(
            this.control.curWidget.attrs.dataSource.dataMapper,
            one1,
            item
        );
        let twoResult = this.getRealShowContent(
            this.control.curWidget.attrs.dataSource.dataMapper,
            two1,
            item
        );
        let res = "";
        if (one2 == ">") {
          res = oneResult > twoResult && two2 == "-" ? "-" : "+";
        } else if (one2 == "<") {
          res = oneResult < twoResult && two2 == "-" ? "-" : "+";
        }
        showMessage += "<span>" + res + "</span>";
        showMessage += "</span>";
      }
      else if (type == "address-province-city" || type == "address-city-district" || 
               type == "address-province" || type == "address-city" || 
               type == "address-district" || type == "address-province-city-district") {
        showMessage = '<span style="display:inline-flex;align-items:center;">';
        message = value.split("{{");
        let a = message[1].substring(0, message[1].length - 2);
        let res = this.getRealShowContent(
            this.control.curWidget.attrs.dataSource.dataMapper,
            a,
            item
        );

        let parts = res ? res.split(",") : [];
        let result = "";

        if (type == "address-province") {
          result = parts[0] || "";
        } else if (type == "address-city") {
          result = parts[1] || "";
        } else if (type == "address-district") {
          result = parts[2] || "";
        } else if (type == "address-province-city") {
          result = (parts[0] || "") + " | " + (parts[1] || "");
        } else if (type == "address-city-district") {
          result = (parts[1] || "") + " | " + (parts[2] || "");
        } else if (type == "address-province-city-district") {
          result = (parts[0] || "") + " | " + (parts[1] || "") + " | " + (parts[2] || "");
        }

        showMessage += "<span>" + result + "</span>";
        showMessage += "</span>";
      }
      else if (type == "textArray") {
        showMessage = '<span style="display:inline-flex;align-items:center;">';
        message = value.split("}}");
        for (var i in message) {
          if (message[i].indexOf("{{") != -1) {
            let a = message[i].split("{{");
            showMessage += "<span>" + a[0] + "</span>";
            let b = a[1];
            let res = "";
            res = this.getRealShowContent(
                this.control.curWidget.attrs.dataSource.dataMapper,
                b,
                item
            );
            if (this.control.curWidget == "McNews" && res[0]) {
              showMessage += "<span>" + res[0].name + "</span>";
            }
          } else {
            showMessage += "<span>" + message[i] + "</span>";
          }
        }
        showMessage += "</span>";
      }
      else if (type == "icon") {
        showMessage = '<span style="display:inline-flex;align-items:center;">';
        message = value.split("{{");
        let a = message[1].substring(0, message[1].length - 2);
        showMessage += '<span class="icon-font-wrapper"><span class="' + "iconfont " + a + '"></span></span>';
        showMessage += "</span>";
      }
      else if (type == "image") {
        showMessage = '<span style="display:inline-flex;align-items:center;">';
        message = value.split("{{");

        let imagePath = this.project.filePath
            ? this.project.filePath
            : "https://cdn.zhaosheng.daheyun1314.com/";
        let a = message[1].substring(0, message[1].length - 2);
        let res = this.getRealShowContent(
            this.control.curWidget.attrs.dataSource.dataMapper,
            a,
            item
        );
        showMessage += '<image src="' + imagePath + res + '" class="w20"></image>';
        showMessage += "</span>";
      }
      else if (type == "priceY") {
        showMessage = '<span style="display:inline-flex;align-items:center;">';
        message = value.split("{{");
        let a = message[1].substring(0, message[1].length - 2);

        let res = this.getRealShowContent(
            this.control.curWidget.attrs.dataSource.dataMapper,
            a,
            item
        );

        if (res) {
          showMessage += "<span>免费</span>";
        } else {
          showMessage += "<span>￥" + res + "</span>";
        }
        showMessage += "</span>";
      }
      else if (type == "priceF") {
        showMessage = '<span style="display:inline-flex;align-items:center;">';
        message = value.split("{{");
        let a = message[1].substring(0, message[1].length - 2);
        let res = this.getRealShowContent(
            this.control.curWidget.attrs.dataSource.dataMapper,
            a,
            item
        );
        if (res == 0) {
          showMessage += "<span>免费</span>";
        } else {
          showMessage += "<span>￥" + (res / 100).toFixed(2) + "</span>";
        }
        showMessage += "</span>";
      } else if (type == "timeYearMonthDay") {
        showMessage = '<span style="display:inline-flex;align-items:center;">';
        message = value.split("{{");
        let a = message[1].substring(0, message[1].length - 2);
        let res = this.getRealShowContent(
            this.control.curWidget.attrs.dataSource.dataMapper,
            a,
            item
        );
        showMessage += "<span>" + res.substring(0, 10) + "</span>";
        showMessage += "</span>";
      } else if (type == "timeYearMonth") {
        showMessage = '<span style="display:inline-flex;align-items:center;">';
        message = value.split("{{");
        let a = message[1].substring(0, message[1].length - 2);
        let res = this.getRealShowContent(
            this.control.curWidget.attrs.dataSource.dataMapper,
            a,
            item
        );
        showMessage += "<span>" + res.substring(0, 7) + "</span>";
        showMessage += "</span>";
      } else if (type == "timeMonthDay") {
        showMessage = '<span style="display:inline-flex;align-items:center;">';
        message = value.split("{{");
        let a = message[1].substring(0, message[1].length - 2);
        let res = this.getRealShowContent(
            this.control.curWidget.attrs.dataSource.dataMapper,
            a,
            item
        );
        showMessage += "<span>" + res.substring(5, 10) + "</span>";
        showMessage += "</span>";
      } else if (type == "timeSecond") {
        showMessage = '<span style="display:inline-flex;align-items:center;">';
        message = value.split("{{");
        let a = message[1].substring(0, message[1].length - 2);
        let res = this.getRealShowContent(
            this.control.curWidget.attrs.dataSource.dataMapper,
            a,
            item
        );
        showMessage += "<span>" + res + "</span>";
        showMessage += "</span>";
      } else if (type == "divider") {
        showMessage = '<span style="color:#232323;display:block;width:100%;">------------------------------------------------------------------------</span>';
      } else {
        showMessage = '<span style="display:inline-flex;align-items:center;">' + (value || "") + '</span>';
      }

      return showMessage;
    },
    cmpStyle(target) {
      if (!target) {
        return {};
      }

      let result = {};

      //,'margin-top','margin-bottom','magin-left','margin-right'

      for (const [key, value] of Object.entries(target)) {
        // 容器负边距
        if (key == "negativeMarginBottom") {
          result["paddingBottom"] = `${value * 2}rpx`;
          continue;
        }

        // 上部内间距
        if (key == "cmpUpperPadding") {
          result["paddingTop"] = `${value * 2}rpx`;
          continue;
        }

        // 下部内间距
        if (key == "cmpLowerPadding") {
          result["paddingBottom"] = `${value * 2}rpx`;
          continue;
        }

        // 上间距
        if (key == "margin-top") {
          result["margin-top"] = `${value * 2}rpx`;
          continue;
        }

        // 下间距
        if (key == "margin-bottom") {
          result["margin-bottom"] = `${value * 2}rpx`;
          continue;
        }

        // 左间距
        if (key == "margin-left") {
          result["margin-left"] = `${value * 2}rpx`;
          continue;
        }

        // 右间距
        if (key == "margin-right") {
          result["margin-right"] = `${value * 2}rpx`;
          continue;
        }

        // 所有圆角
        if (key == "cmpRadius") {
          result["borderRadius"] = `${value * 2}rpx`;
          continue;
        }

        // 上部圆角
        if (key == "cmpUpperRadius") {
          result["borderTopLeftRadius"] = `${value * 2}rpx`;
          result["borderTopRightRadius"] = `${value * 2}rpx`;
          continue;
        }

        // 下部圆角
        if (key == "cmpLowerRadius") {
          result["borderBottomLeftRadius"] = `${value * 2}rpx`;
          result["borderBottomRightRadius"] = `${value * 2}rpx`;
          continue;
        }

        // 组件背景色
        if (key == "cmpBackground") {
          result["background"] = value;
          continue;
        }
        if (key == "color") {
          result["color"] = value;
          continue;
        }
        if (key == "font-size") {
          result["font-size"] = value;
          continue;
        }
        if (key == "font-weight") {
          result["font-weight"] = value;
          continue;
        }
      }

      return result;
    },
    isContentStyleType(type) {
      return type == "text" || type == "textS" || type == "text-s" || 
             type == "text-S" || type == "texts" || 
             (type && type.startsWith("address-"));
    },
    resetContentStyle(key) {
      const style = this.control.curWidget.attrs.decoratorSource.pageStyle[this.curIndex][this.curIndex1][this.curIndex2].style;
      this.$set(style, key, "");
    },
    // 修改选中物料
    setcurComponent() {
      this.$emit("changeCurrWidget", this.data);
    },

    // 删除物料
    delComponent(id) {
      let index = this.control.curPage.componentEntityList.findIndex(
          (item) => item.id == id
      );

      this.control.curPage.componentEntityList.splice(index, 1);

      /*let componentListJson=JSON.parse(this.control.curPage.componentListJson);
      componentListJson.splice(index, 1);*/
      //this.control.curPage.componentListJson=JSON.stringify(this.control.curPage.componentEntityList);

      this.control.curWidget = undefined;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/iconfontDecoration.css";

.decorate-head1 {
  height: 70px;
  /*no*/
  line-height: 70px;
  /*no*/
  padding-left: 12px;
  /*no*/
  border-bottom: 1px solid #f2f4f6;
  font-size: 18px;
  font-weight: 600;
  color: #323233;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .tit {
    flex: 1;
  }

  .iconset {
    margin-right: 15px;
  }

  margin-bottom: 20px;
}

.shape {
  position: relative;

  .shape-tab {
    position: absolute;
    right: -86px;
    /*no*/
    top: 0;
    /*no*/
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    /*no*/
    height: 24px;
    /*no*/
    font-size: 12px;
    /*no*/
    color: #333;
    background: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    &::after {
      content: "";
      position: absolute;
      right: 100%;
      /*no*/
      top: 7px;
      /*no*/
      width: 0;
      /*no*/
      height: 0;
      /*no*/
      border-width: 5px;
      /*no*/
      border-style: solid;
      border-color: transparent;
      margin-bottom: -1px;
      /*no*/
      border-right-width: 5px;
      /*no*/
      border-right-color: currentColor;
      color: #fff;
    }
  }

  .shape-tab-1 {
    position: absolute;
    right: -367px;
    /*no*/
    top: 0;
    /*no*/
    display: flex;
    align-items: center;
    justify-content: center;
    width: 360px;
    /*no*/
    height: 24px;
    /*no*/
    font-size: 12px;
    /*no*/
    color: #333;
    // background: #ffffff;
    /*background: red;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
*/
  }

  .shanchu {
    width: 80px;
    background: #fff;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    height: 24px;
    line-height: 24px;

    &::after {
      content: "";
      position: absolute;
      right: 100%;
      /*no*/
      top: 7px;
      /*no*/
      width: 0;
      /*no*/
      height: 0;
      /*no*/
      border-width: 5px;
      /*no*/
      border-style: solid;
      border-color: transparent;
      margin-bottom: -1px;
      /*no*/
      border-right-width: 5px;
      /*no*/
      border-right-color: currentColor;
      color: #fff;
    }
  }

  .event-none {
    pointer-events: none;
  }

  .tab-icon {
    color: #969799;
    cursor: pointer;

    &:hover {
      color: #87888a;
    }
  }
}

.colSet {
  display: flex;
  align-items: center;
}

.pageRow {
  display: flex;
  align-items: center;

  .colSet:first-child {
    flex-shrink: 0;
  }

  .colSet:nth-child(2) {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }

  .colSet:last-child {
    flex-shrink: 0;
  }
}

.examList {
  //background:#fff;
  width: 350px;
  background: #fff;
  border-radius: 5px;
  padding-bottom: 20px;
  position: absolute;
  top: 30px;
  z-index: 10;
  .li {
    padding: 15px 15px 5px 15px;
    font-size: 12px;
    color: #999;

    .oneRow {
      font-size: 14px;
      color: #333;
      font-weight: bold;
    }
  }
}

.lili {
  display: inline-flex;
  align-items: center;
  height: 34px;
  line-height: 34px;
  background: #f6f7fc;
  padding: 0 10px;
  border-radius: 4px;
  margin-right: 10px;
  color: #333;
}
.icon-font-wrapper {
  display: inline-flex;
  align-items: center;
}
.button-group {
  cursor: pointer;
  &:hover {
    color: #1684fc;
    background: rgba(236, 245, 255, 1);
  }
}
.button_group_active {
  color: #1684fc;
  background: rgba(236, 245, 255, 1);
}

.btnBuy {
  padding: 0 15px;
  height: 26px;
  line-height: 17px;
  border-radius: 9999px;
  background: linear-gradient(
      269.55deg,
      rgba(45, 122, 255, 1) 18.51%,
      rgba(123, 165, 255, 1) 81.31%
  );
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  box-shadow: 0px 2px 6px 0px rgba(141, 181, 254, 0.5);
  text-align: center;
}

.curIndex {
  border: 1px solid red;
}

.setDefStyle {
  border: 1px solid #409fee;
  height: 34px;
  text-align: center;
  line-height: 34px;
  width: 190px;
  font-size: 16px;
  color: #409fee;
  border-radius: 4px;
  cursor: pointer;
}

.resetStyle {
  cursor: pointer;
  height: 34px;
  text-align: center;
  line-height: 34px;
  width: 96px;
  font-size: 16px;
  color: #999;
  border-radius: 4px;
  border: 1px solid rgba(153, 153, 153, 0.3);
}

.setTit {
  padding: 10px 12px;
  /*no*/
  background: #e8f0fb40;
  font-size: 14px;
  /*no*/
  color: #323233;

  span {
    &::before {
      content: ".";
      width: 3px;
      /*no*/
      height: 10px;
      /*no*/
      margin-right: 8px;
      /*no*/
      background: #155bd4;
    }
  }
}

.setHead {
  height: 70px;
  /*no*/
  line-height: 70px;
  /*no*/
  padding-left: 12px;
  /*no*/
  border-bottom: 1px solid #f2f4f6;
  font-size: 18px;
  font-weight: 600;
  color: #323233;
  text-align: left;
}

$color-theme: #155bd4;

.select {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background: #fff;
  align-items: center;

  .select-label {
    display: flex;
    align-items: center;

    .select-label-text {
      width: 77px;
      color: #969799;
      font-size: 13px;
    }
  }

  .select-body {
    display: flex;
    flex-wrap: wrap;
  }
}

.mode-select-item {
  padding: 8px 12px;
  padding: 8px 10px;
  min-width: 55px;
  border: 1px solid #dcdee0;
  /*no*/
  border-radius: 0;
  font-size: 12px;
  /*no*/
  font-weight: 500;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: $color-theme;
    border-color: $color-theme;
    background-color: #e0edff;

    i {
      color: $color-theme;
    }
  }

  i {
    color: #979797;
  }
}

.mode-select-item-active {
  color: $color-theme;
  border-color: $color-theme;
  background-color: #e0edff;

  i {
    color: $color-theme;
  }
}

.style_ul_box {
  padding: 20px 20px 0 20px;
  p {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
  }
  ul {
    li {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      margin-top: 10px;
      line-height: 33px;
      height: 33px;
      border-radius: 4px;
      font-weight: bold;
      span {
        font-size: 12px;
      }
      .time {
        margin-right: 10px;
      }
    }
    .active {
      color: rgba(64, 158, 255, 1);
      background-color: rgba(64, 158, 255, 0.1);
    }
  }
}
.buttonGroup_box {
  width: 380px;
  background: #fff;
  position: fixed;
  top: 59px;
  right: 0px;
  height: 100vh;
  z-index: 1000;
  overflow-x: hidden;
  overflow-y: auto;
}
::v-deep .buttonGroup_box .wrap-body {
  padding: 10px;
}
.buttonGroup_box::-webkit-scrollbar {
  display: none;
}
.McTagNavTree {
  width: 106px;
  background: #fff;
  position: absolute;
  top: 0px;
  padding: 8px 12px;
  border-radius: 8px;
  z-index: 100;
  p {
    cursor: pointer;
    display: flex;
    height: 33px;
    text-align: 33px;
    background-color: rgba(246, 247, 252, 1);
    font-size: 12px;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
    pointer-events: all;
  }
  .active {
    background-color: rgba(236, 245, 255, 1);
    color: rgba(22, 132, 252, 1);
  }
}

.w20 {
  width: 20px;
  height: 20px;
}
</style>

